import React, {ReactNode} from 'react';
import {view, createViewConfig} from '@sail/engine';
import type {View} from '@sail/engine';
import {styles} from 'mkt-ssr/components/sail/SiteFooterSection/SiteFooterListStyles';

export type SiteFooterListProps = View.IntrinsicElement<
  'div',
  {
    /**
     * SiteFooter column section title
     */
    title: string;
    /**
     * The list items to be displayed in the SiteFooterList
     */
    children: ReactNode;
  }
>;

export const SiteFooterListConfig = createViewConfig({
  props: {} as SiteFooterListProps,
  name: 'SiteFooterList',
});

/**
 * Renders a list of links in a column section of the SiteFooter
 */
export const SiteFooterList = SiteFooterListConfig.createView(
  ({title, children, ...rest}) => {
    return (
      <view.div {...rest} uses={[styles.standardSohneSpacing]}>
        <view.h3 uses={[styles.siteFooterListTitle]}>{title}</view.h3>
        <view.ul uses={[styles.siteFooterLinkListStyles]}>{children}</view.ul>
      </view.div>
    );
  },
  {
    uses: styles.siteFooterlinkConfig,
  },
);
